import { __awaiter, __generator } from "tslib";
import HttpClient from '../request/HttpClient';
import { saveLocalData, getLocalData, isCsairApp } from '../app';
var _version = 'v0.1.0';
// 三字码镜像
var codeMirror = {
    countiy: '',
    province: '',
    cityCountryCode3: '',
    cityCode3: '',
    cityName: '',
    airporCode3: '',
    airportName: '',
    airportNameSimple: '',
    airportPhoneticSimple: '',
    airportPhoneticTotal: '',
    isInternational: false,
    busCityTerminalList: []
};
var cityWidget = {};
var request = new HttpClient({
    timeout: 0,
    responseType: 'json',
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'x-requested-with': 'XMLHttpRequest',
    },
}, {
    store: {
        clearData: function (key) {
            if (isCsairApp()) {
                saveLocalData(key, '');
            }
            else {
                localStorage.removeItem(key);
            }
        },
        getData: function (key) {
            return getLocalData(key);
        },
        setData: function (key, data) {
            if (data.code && data.code === '0000' && Array.isArray(data.result)) {
                var codeObj = transformData(data.result);
                codeObj.version = data.version + _version;
                saveLocalData(key, codeObj);
            }
        },
    },
});
/**
 * 数据格式转换 处理/cityWidget/getAllCity接口
 * @param {array} arr
 */
function transformData(arr) {
    if (arr === void 0) {
        arr = [];
    }
    var codeObj = {};
    if (!Array.isArray(arr))
        return codeObj;
    arr.forEach(function (_a) {
        var code3 = _a.code3, cityCountryCode3 = _a.cityCountryCode3, countiy = _a.countiy, name = _a.name, province = _a.province, searchAirportList = _a.searchAirportList, busCityTerminalList = _a.busCityTerminalList, enCountiy = _a.enCountiy, enProvince = _a.enProvince, enName = _a.enName;
        var cityObj = Object.assign({}, codeMirror, {
            cityCountryCode3: cityCountryCode3,
            cityCode3: code3,
            countiy: countiy,
            enCountiy: enCountiy,
            province: province,
            enProvince: enProvince,
            cityName: name,
            cityEnName: enName,
            busCityTerminalList: busCityTerminalList || []
        });
        if (!codeObj[code3]) {
            codeObj[code3] = cityObj;
        }
        if (Array.isArray(busCityTerminalList)) {
            busCityTerminalList.forEach(function (it) {
                var siteCode3 = it.siteCode3;
                it.cityCountryCode3 = cityCountryCode3;
                it.cityCode3 = code3;
                it.countiy = countiy;
                it.enCountiy = enCountiy;
                it.province = province;
                it.enProvince = enProvince;
                it.cityName = name;
                it.cityEnName = enName;
                it.airportName = it.name;
                it.airportEnName = it.enname;
                it.airportNameSimple = it.name;
                it.airportEnNameSimple = it.enname;
                var newObj = {
                    airporCode3: siteCode3,
                };
                codeObj[siteCode3] = Object.assign({}, cityObj, newObj);
            });
        }
        if (Array.isArray(searchAirportList)) {
            searchAirportList.forEach(function (airportItem) {
                var airporCode3 = airportItem.code3;
                var airportObj = {
                    airporCode3: airporCode3,
                    airportName: airportItem.name,
                    airportEnName: airportItem.enName,
                    airportNameSimple: airportItem.nameSimple,
                    airportEnNameSimple: airportItem.enNameSimple,
                    airportPhoneticSimple: airportItem.phoneticSimple,
                    airportPhoneticTotal: airportItem.phoneticTotal,
                    isInternational: airportItem.isInternational === 'Y',
                    busCityTerminalList: busCityTerminalList || []
                };
                codeObj[airporCode3] = Object.assign({}, cityObj, airportObj);
                if (Array.isArray(busCityTerminalList)) {
                    busCityTerminalList.forEach(function (it) {
                        var siteCode3 = it.siteCode3;
                        it.cityCountryCode3 = cityCountryCode3;
                        it.cityCode3 = code3;
                        it.countiy = countiy;
                        it.enCountiy = enCountiy;
                        it.province = province;
                        it.enProvince = enProvince;
                        it.cityName = name;
                        it.cityEnName = enName;
                        it.airportName = it.name;
                        it.airportEnName = it.enname;
                        it.airportNameSimple = it.name;
                        it.airportEnNameSimple = it.enname;
                        it.airportPhoneticSimple = airportItem.phoneticSimple;
                        it.airportPhoneticTotal = airportItem.phoneticTotal;
                        it.isInternational = airportItem.isInternational === 'Y';
                        var newObj = {
                            airporCode3: siteCode3,
                        };
                        codeObj[siteCode3] = Object.assign({}, cityObj, airportObj, newObj);
                    });
                }
            });
        }
        return codeObj;
    });
    return codeObj;
}
function getCode3Data() {
    return request.createHttp('get', '/EMP/getAllCity', { cache: 'local', loading: false });
}
function getCode3DataVersion() {
    return request.createHttp('get', '/EMP/getVersion', { loading: false });
}
/**
 * 匹配三字码
 * @param {string} 机场三字码
 * @returns {string}
 */
export function getCode3Widget(code3, ftype, lang) {
    if (lang === void 0) {
        lang = "cn";
    }
    if (!code3)
        return codeMirror;
    // if (ftype && ftype === "BUS") {
    //   return cityWidget[code3].busCityTerminalList.filter(it = it.siteCode3 == code3).length > 0
    //     ? cityWidget[code3].busCityTerminalList.filter(it = it.siteCode3 == code3)
    //     : codeMirror
    // }
    var ftypeTest = /bus/i;
    if (lang.toLocaleLowerCase().indexOf('en') !== -1) {
        var codeInfo = cityWidget[code3] || codeMirror;
        if (ftype && ftypeTest.test(ftype)) {
            if (cityWidget[code3]) {
                codeInfo = cityWidget[code3].busCityTerminalList.filter(function (it) { return it.siteCode3 == code3; })[0] || cityWidget[code3] || codeMirror;
            }
        }
        codeInfo.countiy = codeInfo.enCountiy;
        codeInfo.province = codeInfo.enProvince;
        codeInfo.cityName = codeInfo.cityEnName;
        codeInfo.airportName = codeInfo.airportEnName;
        codeInfo.airportNameSimple = codeInfo.airportEnNameSimple;
        return codeInfo;
    }
    if (ftype && ftypeTest.test(ftype)) {
        if (cityWidget[code3]) {
            return cityWidget[code3].busCityTerminalList.filter(function (it) { return it.siteCode3 == code3; })[0] || (cityWidget[code3] || codeMirror);
        }
    }
    return cityWidget[code3] || codeMirror;
}
/**
 * 创建城市控件数据
 */
export function createCode3Widget() {
    return __awaiter(this, void 0, void 0, function () {
        var _a, errorCode, cacheData, config, status, data, version;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getCode3Data()];
                case 1:
                    _a = _b.sent(), errorCode = _a.errorCode, cacheData = _a.cacheData, config = _a.config, status = _a.status, data = _a.data;
                    if (status === 200) {
                        cityWidget = transformData(data.result);
                        cityWidget.version = data.version;
                        return [2 /*return*/, false];
                    }
                    if (!(errorCode && errorCode === 3040))
                        return [3 /*break*/, 3];
                    cityWidget = cacheData;
                    return [4 /*yield*/, getCode3DataVersion()];
                case 2:
                    version = _b.sent();
                    if (typeof version.data === 'number' &&
                        cacheData.version &&
                        cacheData.version !== version.data + _version) {
                        config.clearCache();
                        createCode3Widget();
                    }
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * 获取机场简称, 即去掉城市名
 * @returns {string}
 */
export function getAbAirport(codeData) {
    return codeData.airportNameSimple
        ? codeData.airportNameSimple === codeData.cityName
            ? codeData.airportNameSimple
            : codeData.airportNameSimple.replace(codeData.cityName, '')
        : '';
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/code3Widget.js
// module id = null
// module chunks = 